import React from 'react';
import styled from 'styled-components';
import { RATING_ACCENT_COLOR, RATING_TRACK_COLOR } from './constants';
import { MAX_RATING, toStarFillPercentage } from '../../section/Common/utils/ratingDistribution';

interface IStarRatingProps {
  rating: number;
  size?: number;
}

const STARS = '★'.repeat(MAX_RATING);

const Stars = styled.span<{ size: number }>`
  position: relative;
  display: inline-block;
  font-size: ${({ size }) => size}px;
  line-height: 1;
  letter-spacing: 1px;
  white-space: nowrap;
  color: ${RATING_TRACK_COLOR};
`;

// Clipped copy of the same glyphs, so the half star lands wherever the font puts it.
const Filled = styled.span<{ percentage: number }>`
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  width: ${({ percentage }) => percentage}%;
  color: ${RATING_ACCENT_COLOR};
`;

const StarRating: React.FC<IStarRatingProps> = ({ rating, size = 14 }) => (
  <Stars aria-hidden data-testid='star-rating' size={size}>
    {STARS}
    <Filled percentage={toStarFillPercentage(rating)}>{STARS}</Filled>
  </Stars>
);

export default StarRating;
